import { useFormContext, useWatch } from 'react-hook-form';
import { useEffect } from 'react';
import { ContentSection } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Stack, StackItem } from '@optimus-web/core';
import { CurrencyInputField } from '@mews-commander/form';
import { CurrencySelectField } from '../../../../../components/form/hookFields';
import { useCurrencyFormat } from '../../../../../core/globalization/hooks/useCurrencyFormat';
import { AllowanceFormValues } from '../../schemas/allowanceFormSchema';

export const AllowancePricingSection = () => {
    const { setValue } = useFormContext<AllowanceFormValues>();
    const currencyCode = useWatch({ name: 'pricing.currency' });
    const currencyFormat = useCurrencyFormat(currencyCode);
    const price = useWatch({ name: 'pricing.price' });

    useEffect(() => {
        setValue('pricing.creditAmount', price);
    }, [price, setValue]);

    return (
        <ContentSection
            title={lt('Pricing')}
            description={lt('AllowanceFormPricingSectionDescription')}
            spacing="300"
            contentSpacing="200"
        >
            <Stack spacing="100" fill>
                <StackItem grow>
                    <CurrencyInputField
                        autoFocus
                        required
                        name="pricing.price"
                        label={lt('Price')}
                        {...currencyFormat}
                    />
                </StackItem>
                <StackItem minWidth="25%">
                    <CurrencySelectField
                        currencyScope="currentEnterprise"
                        disabled
                        label={lt('Currency')}
                        name="pricing.currency"
                        required
                    />
                </StackItem>
            </Stack>
            <CurrencyInputField
                name="pricing.creditAmount"
                label={lt('AllowanceFormInputLabelAllowance')}
                disabled
                {...currencyFormat}
            />
        </ContentSection>
    );
};
